/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SearchContainersEquipmentResponse { 
    id: string;
    statusId: number;
    modelName?: string | null;
    ipAddress?: string | null;
    chipTemperature: number;
    boardTemperature: number;
    currentPower: number;
    uptime?: number | null;
    collectedAt?: string | null;
    telemetryFresh?: boolean;
    currentHashrate: number;
    hashrateUnitId: number;
}

